import { Api } from '../api/Api.js'
import { ref } from 'vue';

export function apiGetCitiesDischarge(params) {
  return Api('get', '/get_cities_discharge', { params });
}


export const loadingGetCities = ref(false);
export const  pageCities = ref(1);
export const  cities = ref([]);
export const  hasNextPageCities = ref(false);

export async function getCities(search = '') {
  loadingGetCities.value = true
  try {
    const response = await apiGetCitiesDischarge({
      search: search,
      page: pageCities.value
    })

    if(!response) return
    if(pageCities.value === 1) {
      cities.value = response?.data?.cities?.data
    } else {
      cities.value = [...cities.value, ...response?.data?.cities?.data]
    }
    hasNextPageCities.value = pageCities.value < response?.data?.cities?.last_page

  } catch (error) {
    console.log(error)
  } finally {
    loadingGetCities.value = false
  }
}

export function loadMoreCities(arg) {
  if(arg?.page) {
    pageCities.value = arg.page
  } else {
    pageCities.value++
  }

  if(pageCities.value === 1) {
    cities.value = []
  }
  getCities(arg?.search || '')
}

